import { render, staticRenderFns } from "./item-test.vue?vue&type=template&id=0eebc6df&"
import script from "./item-test.vue?vue&type=script&lang=js&"
export * from "./item-test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports